import { makeStyles } from "@cirrus/ui-kit"

import React, { Component as C, Fragment } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import { StatelessTextInput } from "@cirrus/legacy/app-components/entries/lib.js"
import { darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import { withUseStyles } from "@cirrus/legacy/app-common/utils/withUseStyles.jsx"

import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import fs from "@cirrus/legacy/app-components/app/styles/font-size-variables.less"

const useStyles = makeStyles({
  globalPageTitle: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "15px",

    "&:hover": {
      "& $pencilIcon": {
        display: "block",
        "&:hover": { color: cv.red300 },
      },
    },
  },

  pageTitle: {
    display: "inline-block",
    lineHeight: fs.pageTitleLineHeight,
    fontSize: fs.pageTitleFontSize,
    fontWeight: "700",
    marginTop: "0",
    marginBottom: "0",
    marginRight: "5px",
    color: cv.gray850,
    "&:hover": { cursor: "pointer" },
  },

  icon: {
    zIndex: "11000",
    "&:hover": { cursor: "pointer" },
  },

  pencilIcon: {
    display: "none",
    fontSize: "25px",
    color: cv.gray850,
  },

  iconRed: {
    fontSize: "30px",
    color: cv.red300,
    "&:hover": { color: `${darken(5, cv.red300)}` },
  },

  iconGreen: {
    fontSize: "30px",
    color: cv.green300,
    "&:hover": { color: `${darken(5, cv.green300)}` },
  },

  textInput: {
    width: "700px",
    height: "40px",
    marginRight: "5px",
    lineHeight: fs.pageTitleLineHeight,
    fontSize: fs.pageTitleFontSize,
    fontWeight: "700",
    marginTop: "0",
    marginBottom: "0",
    color: cv.gray850,
    paddingLeft: "0",
    zIndex: "11000",
  },

  titleValidation: {
    color: cv.red410,
    flexBasis: "100%",
  },

  overlay: {
    position: "fixed",
    display: "block",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "transparent",
    zIndex: "10000",
  },
})

class EditablePageTitle extends C {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    tempTitle: PropTypes.string,
    isEditActive: PropTypes.bool,
    onChangeTitle: PropTypes.func,
    onSubmit: PropTypes.func,
    onStartEditing: PropTypes.func,
    errorText: PropTypes.string,
  }

  static displayName = "Editable_Page_Title"

  onIconClick = () => {
    this.props.onStartEditing()
  }

  focusOnTitle = (e) => {
    const { value } = e.target

    e.target.value = ""
    e.target.value = value
  }

  onKeyDown = (e) => {
    if (e.key === "Enter") {
      return e.target.blur()
    }

    if (e.key === "Escape") {
      this.props.onCancel()
    }
  }

  render() {
    const {
      containerClassName,
      className,
      isEditActive,
      isValid,
      onSubmit,
      tempTitle,
      title,
      onCancel,
      errorText,
      classes,
      editableTitleContainerClass,
      titleContainerClass,
      errorClass,
    } = this.props

    const containerClass = classNames(containerClassName, classes.globalPageTitle)

    const titleClass = classNames(classes.pageTitle, className)

    return (
      <div
        className={classNames(containerClass, {
          [titleContainerClass]: !isEditActive,
          [editableTitleContainerClass]: isEditActive,
        })}
        data-qa="page-editable-title">
        {!isEditActive ? (
          <h2 className={titleClass}>{title}</h2>
        ) : (
          <Fragment>
            <StatelessTextInput
              type="text"
              onChange={(e, value) => {
                this.props.onChangeTitle(value)
              }}
              className={classes.textInput}
              notValid={!isValid}
              value={tempTitle}
              dataQa="edit-title-input"
              onBlur={() => {
                isValid ? onSubmit(tempTitle) : null
              }}
              onFocus={this.focusOnTitle}
              onKeyDown={this.onKeyDown}
              autoFocus
            />
          </Fragment>
        )}

        {!isEditActive ? (
          <Icon
            icon={"fa-pencil"}
            className={classNames(classes.pencilIcon, classes.icon)}
            onClick={this.onIconClick}
          />
        ) : (
          <Icon
            icon={isValid ? "fa-check" : "fa-times"}
            className={classNames(isValid ? classes.iconGreen : classes.iconRed, classes.icon)}
            onClick={() => {
              !isValid ? onCancel() : null
            }}
          />
        )}

        <div className={classNames(classes.titleValidation, isValid ? "hidden" : null, errorClass)}>
          {errorText}
        </div>

        {!isValid && <div className={classes.overlay} />}
      </div>
    )
  }
}

export default withUseStyles(EditablePageTitle, useStyles)
